import {
  Spot,
  SaleTicket,
  TicketWithSaleTickets,
  SaleTicketWithSpots,
  TicketWithSpots,
  SpotWithSaleTickets,
} from "../global-commons/type";
import { DATA_BLOCK } from "./dataBlockUtil";
import { saleTicketFromSpotCache, spotFromSaleTicketCache } from "./cache";
import { Languages } from "../global-commons/i18n/base";

export async function getSaleTicketWithSpots(
  id: number,
  searchApiUrl: string,
  lang: Languages
): Promise<TicketWithSaleTickets[]> {
  // cache read
  const cacheResult = saleTicketFromSpotCache.get(id);
  if (cacheResult) {
    return cacheResult;
  }
  const searchParams = new URLSearchParams();
  searchParams.append("lang", lang);
  const result = await fetch(
    searchApiUrl +
      "/sale-ticket-from-spot/" +
      id +
      "?" +
      searchParams.toString()
  );
  if (!result.ok) {
    throw new Error(
      "getSaleTicketWithSpots returns non-ok status: " + result.status
    );
  }
  const saleTicketWithSpots = await result.json();
  saleTicketFromSpotCache.set(id, saleTicketWithSpots);
  return saleTicketWithSpots;
}

/** SaleTicket[]型をSaleTicketWithSpots[]に変換する */
export async function appendTicketWithSpot(
  saleTickets: SaleTicket[]
): Promise<SaleTicketWithSpots[]> {
  const SEARCH_API_URL = DATA_BLOCK.getEnv().SEARCH_API_URL;
  if (!SEARCH_API_URL) {
    throw new Error("SEARCH_API_URL is not set");
  }

  const saleTicketsWithSpot: SaleTicketWithSpots[] = [];
  for (const saleTicket of saleTickets) {
    let ticketsWithSpots: TicketWithSpots[];
    // cache get
    const cacheResult = spotFromSaleTicketCache.get(saleTicket.topics_id);

    if (cacheResult) {
      ticketsWithSpots = cacheResult;
    } else {
      const response = await fetch(
        SEARCH_API_URL + "/spot-from-sale-ticket/" + saleTicket.topics_id
      );
      if (!response.ok) {
        throw new Error(
          "Failed to fetch spot from sale ticket " +
            saleTicket.topics_id +
            "with status " +
            response.status
        );
      }
      ticketsWithSpots = await response.json();
      // cache set
      spotFromSaleTicketCache.set(saleTicket.topics_id, ticketsWithSpots);
    }
    saleTicketsWithSpot.push({ ...saleTicket, tickets: ticketsWithSpots });
  }
  return saleTicketsWithSpot;
}

export async function getSpotWithSaleTickets(
  id: number,
  searchApiUrl: string,
  lang: Languages
): Promise<TicketWithSpots[]> {
  // cache read
  const cacheResult = spotFromSaleTicketCache.get(id);
  if (cacheResult) {
    return cacheResult;
  }
  const searchParams = new URLSearchParams();
  searchParams.append("lang", lang);
  const result = await fetch(
    searchApiUrl +
      "/spot-from-sale-ticket/" +
      id +
      "?" +
      searchParams.toString()
  );
  if (!result.ok) {
    throw new Error(
      "getSpotWithSaleTickets returns non-ok status: " + result.status
    );
  }
  const spotWithSaleTicket: TicketWithSpots[] = await result.json();
  // cache set
  spotFromSaleTicketCache.set(id, spotWithSaleTicket);
  return spotWithSaleTicket;
}

/** Spot[]型をSpotWithSaleTickets[]に変換する */
export async function appendTicketWithSaleTickets(
  spots: Spot[]
): Promise<SpotWithSaleTickets[]> {
  const SEARCH_API_URL = DATA_BLOCK.getEnv().SEARCH_API_URL;
  if (!SEARCH_API_URL) {
    throw new Error("SEARCH_API_URL is not set");
  }

  const spotsWithSaleTickets: SpotWithSaleTickets[] = [];
  for (const spot of spots) {
    let ticketsWithSaleTickets: TicketWithSaleTickets[];
    const cacheResult = saleTicketFromSpotCache.get(spot.topics_id);

    if (cacheResult) {
      ticketsWithSaleTickets = cacheResult;
    } else {
      const response = await fetch(
        SEARCH_API_URL + "/sale-ticket-from-spot/" + spot.topics_id
      );
      if (!response.ok) {
        throw new Error(
          "Failed to fetch sale ticket from spot " +
            spot.topics_id +
            "with status " +
            response.status
        );
      }
      ticketsWithSaleTickets = await response.json();
      saleTicketFromSpotCache.set(spot.topics_id, ticketsWithSaleTickets);
    }
    spotsWithSaleTickets.push({ ...spot, tickets: ticketsWithSaleTickets });
  }
  return spotsWithSaleTickets;
}
